export default {
    data() {
      return {
        //表格数据数组
        navigationShows: [],
        //添加导航弹窗状态
        dialogFormVisible: false,
        //修改导航弹窗状态
        dialogEidtVisible:false,

       //添加导航弹窗内的数据
       //导航名称、链接、排序
        form:{
          navName:'',
          navUrl:'',
          navSort:'',
        },
        //编辑弹窗内的数据
        //导航名称、链接、排序
        update:{
          id: '',
          navName:'',
          navUrl:'',
          navSort:'',
        },
        
        formLabelWidth: '120px'
    
      }
    },
    methods: {
      //编辑
      handleEdit(obj) {
        // console.log(obj);
            this.dialogEidtVisible = true;
            this.update.id = obj.id;
            this.update.navName = obj.name;
            this.update.navUrl = obj.url;
            this.update.navSort=obj.sort;
      },
      //删除
      handleDelete(id) {
        this.$confirm('此操作将永久删除该导航, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmNavDelete(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
      },
      //获取表格数据
      getData() {
        // 获取数据
        let data = {
            token: this.$store.state.authority_management,
            offset: 0,
            length: 999,
        };
        //发起请求获取所有导航信息
        this.$post('navigation_bar/shop_search', data).then(res => {
            this.navigationShows = res.data.result.data;
            // console.log(this.navigationShows);
        })
      },
      //增加导航
      confirmNavigation(){
         //三个条件的表单校验，导航名字不能空，链接不能为空，排序要写好
            if (this.form.navName == '') {
                this.$message({
                    showClose: true,
                    type: 'error',
                    message: '导航名不能为空'
                });
                return false;
            }else if(this.form.navSort == ''){
              this.$message({
                showClose: true,
                type: 'error',
                message: '导航排序不能为空'
              });
            }
            else if(isNaN(this.form.navSort)){
              this.$message({
                showClose: true,
                type: 'error',
                message: '导航排序必须为数字'
              });
            }else{
              let data = {
                name: this.form.navName,
                url: this.form.navUrl,
                sort: this.form.navSort,
                token:this.$store.state.authority_management
              }
              //发起添加导航请求
              this.$post('navigation_bar/shop_create',data).then(res=>{
                if(res.data.status == 'success'){
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: '添加 导航成功'
                  });
                  //关闭弹窗
                  this.dialogFormVisible = false;
                  //清空表单
                  this.form.navName = '';
                   this.form.navUrl = '';
                    this.form.navSort = '';
                    //重新请求数据
                    this.getData()

                }
              })

            }
      },
      //删除导航
      confirmNavDelete(id){
        let data={
                token:this.$store.state.authority_management,
                id:id
            }
            this.$post('navigation_bar/shop_delete',data).then(res=>{
                if(res.data.status =='success'){
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    //删除成功后请求刷新数据
                    this.getData();
                }else{
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    });
                }
            })

      },
      //修改数据
      confirmUpdateImNav(){
        if(this.update.navName == ''){
          this.$message({
            showClose: true,
            message: "导航名不能为空",
            type: "error"
          });
          return false;
        }else{
          let data = {
                token:this.$store.state.authority_management,
                id: this.update.id,
                name: this.update.navName,
                url: this.update.navUrl,
                sort: this.update.navSort
          };
          this.$post('navigation_bar/shop_edit',data).then(res=>{
            if(res.data.status == 'success'){
              this.$message({
                showClose: true,
                message: '编辑成功',
                type:'success'
              });
              //更新后重新请求数据刷新
              this.getData();
              this.dialogEidtVisible = false
            }else{
              this.$message({
                showClose: true,
                message: '编辑失败',
                type:'error'
              })
            }
          })
        }
        
      }
    }
    ,
    created(){
      //获取表格数据
      this.getData();
    }


    
  }